const FRENCH_SILENT_H_WORDS = [
  "habiller",
  "habiter",
  "habituer",
  "honorer",
  "horrifier",
  "hospitaliser",
  "humidifier",
  "humilier",
  "hyperboliser",
  "héberger",
  "héliporter",
  "hériter"
];

const VOWELS = [
  // General
  "a",
  "e",
  "i",
  "o",
  "u",

  // Danish
  "æ",
  "ø",
  "å",

  // Latin-ish languages
  "á",
  "à",
  "â",
  "ã",
  "ä",
  "é",
  "è",
  "ê",
  "ë",
  "í",
  "ì",
  "î",
  "ï",
  "ó",
  "ò",
  "ô",
  "õ",
  "ö",
  "ú",
  "ù",
  "û",
  "ü",
  "ý",
  "ÿ"
];

export function isVowel(char: string): boolean {
  return VOWELS.includes(char.toLowerCase());
}

export function startsWithVowel(word: string, language?: "fr"): boolean {
  if (language === "fr" && FRENCH_SILENT_H_WORDS.includes(word.toLowerCase())) {
    return true;
  }

  return isVowel(word.charAt(0).toLowerCase());
}
